import { Component } from '@angular/core';
import { DemoRolesService } from 'src/app/service/demo-roles.service';
import { ImpersonateService } from 'src/app/service/impersonate.service';

@Component({
  selector: 'flow-demo-roles',
  templateUrl: './demo-roles.component.html',
  styleUrls: ['./demo-roles.component.scss']
})
export class DemoRolesComponent {
  public sortByCol = 'first_name';

  constructor(
    public service : DemoRolesService,
    public impersonate : ImpersonateService,
  ) { }

  selectedEmployee : string = '';

  select() {
    if(this.selectedEmployee != '' ) {
      let employee = this.service.employees.find((e) => e['email'] == this.selectedEmployee) || null;
      this.impersonate.$selected.next(employee);
    }
    else {
      this.impersonate.$selected.next(null);
    }
  }

  reset() {
    this.selectedEmployee = '';
    this.impersonate.$selected.next(null);
  }
}
